import { render, staticRenderFns } from "./ItemizeBankcard.vue?vue&type=template&id=0c733500"
import script from "./ItemizeBankcard.vue?vue&type=script&lang=js"
export * from "./ItemizeBankcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports